export default {
  getSharedEnv: (_ref) => {
    let {
      payload
    } = _ref;
    return payload;
  },
  tracking: (_ref2) => {
    let {
      payload
    } = _ref2;
    return payload.tracking;
  },
  oauth: (_ref3) => {
    let {
      payload
    } = _ref3;
    return payload.oauth;
  }
};